/** Jurisdictions Vera can evaluate — mirrors rule-pack.json entries. */
export const ACC_JURISDICTION_OPTIONS = [
  {
    id: "us-ca-la-county",
    label: "Los Angeles County, CA (California Residential Code)",
  },
  {
    id: "us-ny-nyc",
    label: "New York City, NY (NYC Building Code)",
  },
  {
    id: "sg-bca",
    label: "Singapore (BCA Code on Accessibility)",
  },
] as const;

export type AccJurisdictionId = (typeof ACC_JURISDICTION_OPTIONS)[number]["id"];
